(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cstm-wholesale-form"] && !Shopify.designMode) return;
  try {
    
     var formCss = setInterval(function() {
      let appEmbed = document.querySelector('#app-embed');
      if (appEmbed) {
          let shadowRoot = appEmbed.shadowRoot;
          if (shadowRoot) {
              let mainform = shadowRoot.querySelector('._inline_stahb_47 ._formContainer_stahb_30');
              let mainformheading = shadowRoot.querySelector('._textHeading_2aowh_35');
              let bottomformtext = shadowRoot.querySelector('._formDisclaimer_1ll8d_37');
              let formbillingtext = shadowRoot.querySelectorAll('._formFieldset_1ll8d_67 legend');
              let checkboxtext = shadowRoot.querySelector('._checkboxField_11ej1_1 span');
              let submitbutton = shadowRoot.querySelector('._formSubmitButton_1ll8d_81');
              let uploadlabeltext = shadowRoot.querySelectorAll('._formFileInput_ehvsf_1>p');
              let uploadbutton = shadowRoot.querySelectorAll('._formFileInputField_ehvsf_5  ');
              let uploadbuttontext=shadowRoot.querySelectorAll('._formFileInputButton_ehvsf_18');
              // let inputlabel=shadowRoot.querySelectorAll('._formInputFieldLabel_1ydxd_37');
              // let inputs=shadowRoot.querySelectorAll('._formFieldContainer_1ydxd_5');

              if (mainform) {
                  mainform.setAttribute('style', 'max-width:100%');
                  clearInterval(formCss);
              }
              if (mainformheading) {
                  mainformheading.setAttribute('style', 'margin-top:37px;font-size:35px;line-height:40px;font-weight:800;');
                  clearInterval(formCss);
              }
             if (bottomformtext) {
                  bottomformtext.setAttribute('style', 'display:none');
                  clearInterval(formCss);
              }
            if (formbillingtext) {
                  var i;
                  for (i = 0; i < formbillingtext.length; ++i) {
                    formbillingtext[i].setAttribute('style','font-family:Barlow Condensed;font-size:19px;line-height:28.5px;font-weight:500;');
                  }
                  clearInterval(formCss);
              }
            if (checkboxtext) {
                  checkboxtext.setAttribute('style', 'font-family:Barlow Condensed;font-size:16px;line-height:24px;font-weight:500;');
                  clearInterval(formCss);
              }
            if (submitbutton) {
                  submitbutton.setAttribute('style', 'padding:16px 32px 16px 32px;font-size:20px;line-height:30px;font-weight:800;background-color:#091D3A;margin-top:37px');
                  clearInterval(formCss);
              }

            if (uploadlabeltext) {
                 var i;
                 for (i = 0; i < uploadlabeltext.length; ++i) {
                  uploadlabeltext[i].setAttribute('style','font-size:15px;font-weight:800;line-height:19px;');

                 }
                 clearInterval(formCss);
             }
            if (uploadbutton) {
                 var i;
                 for (i = 0; i < uploadbutton.length; ++i) {
                  uploadbutton[i].setAttribute('style','background-color:#091D3A;border:none;padding:0px 16px 0px 16px;');
                 }
                 clearInterval(formCss);
             }
            if (uploadbuttontext) {
                 var i;
                 for (i = 0; i < uploadbuttontext.length; ++i) {
                  uploadbuttontext[i].setAttribute('style', 'color:white;font-size:18px;line-height:20px;font-weight:800;background-color:transparent');
                 }
                 clearInterval(formCss);
             }
            // if (inputlabel) {
            //      var i;
            //      for (i = 0; i < inputlabel.length; ++i) {
            //       inputlabel[i].setAttribute('style', 'top:50%;transform:translateY(-50%);transition:all 1s;');
            //      }
            //      clearInterval(formCss);
            //  }
            // if (inputs) {
            //      var i;
            //      for (i = 0; i < inputs.length; ++i) {
            //        // inputs[i].focus().setAttribute('style','top:16px;transform:translateY(0) scale(0.85)');
            //        inputs[i].addEventListener("focus", function () {
            //           inputlabel[i].style.top = "16px";
            //           inputlabel[i].style.transform ="translateY(0) scale(0.85)";
            //         });
            //        // var visibleInput = inputs[i].filter(':visible');
            //        //  var afterfocus= visibleInput.focus();
            //        // afterfocus.setAttribute('style','top:16px;transform:translateY(0) scale(0.85)')
            //      }
            //      clearInterval(formCss);
            //  }
          }
      }
  }, 200);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-luma"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header.section-header-luma');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
